import React from "react";
import { Link } from "react-router-dom";
import logo from "../../gallery/logo.png";
import { useEffect } from "react";
import { PersonCircle } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { setActiveLink } from "../../app/features/nav/navSlice";
import { logoutUser, setSignup, setUser } from "../../app/features/user/userSlice.js";
import { getCurrentUser, logout } from "../../api/customAxios.js";
import AuthModal from "../common/AuthModal.js";
require("../../css/navbar.css");
require("../../js/navbar.js");

function Navbar() {
  const dispatch = useDispatch();
  const activeItem = useSelector((state) => state.nav.activeLink);
  let user = useSelector((state) => state.user.user);

  async function logOut() {
    try {
      await logout();

      dispatch(logoutUser());
      localStorage.removeItem("user");
      sessionStorage.removeItem("user");

      window.location.href = "/";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  }
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser();
        if (user) {
          dispatch(setUser(user));
        }
      } catch (error) {}
    };
    checkAuth();
    // Retrieve the active link from storage on component mount
  }, [activeItem]);
  const mobileNav = function (event) {
    if (document.body.classList.contains("nav2-is-toggled")) {
      document.body.classList.remove("nav2-is-toggled");
    } else {
      document.body.classList.add("nav2-is-toggled");
    }
    if (document.body.classList.contains("body-no-scroll")) {
      document.body.classList.remove("body-no-scroll");
    } else {
      document.body.classList.add("body-no-scroll");
    }
    if (document.getElementById("ham").textContent === "menu") {
      document.getElementById("ham").textContent = "close";
    } else {
      document.getElementById("ham").textContent = "menu";
    }
  };
  function goToTop(activeLink) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    dispatch(setActiveLink(activeLink));
  }
  const goToAuthModalDesktop = () => {
    const navBar = document.querySelector(".navbar");
    if (navBar && navBar.classList.contains("sticky-top")) {
      navBar.classList.remove("sticky-top");
    }

    const modalEl = document.getElementById("authModal");
    if (modalEl) {
      modalEl.addEventListener(
        "hidden.bs.modal",
        () => {
          if (navBar && !navBar.classList.contains("sticky-top")) {
            navBar.classList.add("sticky-top");
          }
        },
        { once: true }
      );
    }
  };
  const goToAuthModalMobile = () => {
    // Close mobile nav overlay
    document.body.classList.remove("nav2-is-toggled", "body-no-scroll");

    // Reset hamburger icon
    const ham = document.getElementById("ham");
    if (ham) ham.textContent = "menu";

    // Remove sticky-top temporarily
    const navBar = document.querySelector(".navbar");
    if (navBar && navBar.classList.contains("sticky-top")) {
      navBar.classList.remove("sticky-top");
    }

    // Add listener to reapply sticky-top on modal close
    const modalEl = document.getElementById("authModal");
    if (modalEl) {
      modalEl.addEventListener(
        "hidden.bs.modal",
        () => {
          if (navBar && !navBar.classList.contains("sticky-top")) {
            navBar.classList.add("sticky-top");
          }
        },
        { once: true }
      );
    }
  };

  const goToSignup = () => {
    dispatch(setSignup());

    // Close mobile nav overlay
    document.body.classList.remove("nav2-is-toggled", "body-no-scroll");

    // Reset hamburger icon
    const ham = document.getElementById("ham");
    if (ham) ham.textContent = "menu";

    // Remove sticky-top temporarily
    const navBar = document.querySelector(".navbar");
    if (navBar && navBar.classList.contains("sticky-top")) {
      navBar.classList.remove("sticky-top");
    }

    // Add listener to reapply sticky-top on modal close
    const modalEl = document.getElementById("authModal");
    if (modalEl) {
      modalEl.addEventListener(
        "hidden.bs.modal",
        () => {
          if (navBar && !navBar.classList.contains("sticky-top")) {
            navBar.classList.add("sticky-top");
          }
        },
        { once: true }
      );
    }
  };
  return (
    <>
      {!user && <AuthModal />}
      <nav className="navbar navbar-expand-lg nav-background sticky-top">
        <div className="container">
          <Link onClick={() => goToTop("home")} to="/" className="navbar-logo">
            <img src={logo} alt={"Sahi Search"} style={{ width: "150px" }} />
          </Link>
          <button className="navbar-toggler" type="button">
            <span className="hamburger material-icons" id="ham" onClick={mobileNav}>
              menu
            </span>
          </button>

          <div className="hidden-xs hidden-sm" style={{ width: "100%" }}>
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <Link onClick={() => goToTop("home")} className={activeItem === "home" ? "nav-link active" : "nav-link"} aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link onClick={() => goToTop("event")} className={activeItem === "event" ? "nav-link active" : "nav-link"} aria-current="page" to="/events">
                  Events
                </Link>
              </li>
              <li className="nav-item">
                <a onClick={() => goToTop("event")} className="nav-link" aria-current="page" href={`${process.env.REACT_APP_STORE_URL}`}>
                  Store
                </a>
              </li>
              <li className="nav-item">
                <Link onClick={() => goToTop("business")} className={activeItem === "business" ? "nav-link active" : "nav-link"} aria-current="page" to="/search?category=1&location=1&page=1&limit=10&sort=null">
                  Businesses
                </Link>
              </li>
              <li className="nav-item">
                <Link onClick={() => goToTop("property")} className={activeItem === "property" ? "nav-link active" : "nav-link"} aria-current="page" to="/search?category=3&location=1&page=1&limit=10&sort=null&type=0&gender=3&ctax=0&sharing=0&deposit=0&bills=0">
                  Rooms for Rent
                </Link>
              </li>
              <li className="nav-item">
                <Link onClick={() => goToTop("job")} className={activeItem === "job" ? "nav-link active" : "nav-link"} aria-current="page" to="/search?category=2&location=1&page=1&limit=10&sort=null&title=&job=0&level=0&disclosed=0">
                  Jobs
                </Link>
              </li>
              {user ? (
                <>
                  <li className="nav-item login-signup mt-2 ms-auto" style={{ marginRight: "20px" }}>
                    <a className="custom-color" href={`${process.env.REACT_APP_BASE_URL}`}>
                      <PersonCircle size={22} />
                      &nbsp;&nbsp;
                      {user.email}
                    </a>
                  </li>
                  <li className="nav-item">
                    <button className="ms-auto btn btn-nav-light hidden-xs hidden-sm" onClick={logOut}>
                      Logout
                    </button>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item login-signup mt-2 ms-auto" style={{ marginRight: "20px" }} data-bs-toggle="modal" data-bs-target="#authModal" onClick={goToAuthModalDesktop}>
                    <span className={"login-signup-link"}>Log in</span>
                    &nbsp;/&nbsp;
                    <span className={"login-signup-link"}>Sign up</span>
                  </li>

                  <li className="nav-item">
                    <a href={`${process.env.REACT_APP_BASE_URL}/register`} type="button" className="ms-auto btn btn-nav-light hidden-xs hidden-sm">
                      Start listing for free
                    </a>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
      <div className="mobile-nav">
        <nav className="nav2-drill">
          <ul className="nav2-items nav2-level-1">
            <li className="nav2-item">
              <Link onClick={() => goToTop("home")} className={activeItem === "home" ? "nav2-link active" : "nav2-link"} aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav2-item">
              <Link onClick={() => goToTop("event")} className={activeItem === "event" ? "nav2-link active" : "nav2-link"} aria-current="page" to="/events">
                Events
              </Link>
            </li>
            <li className="nav2-item">
              <a onClick={() => goToTop("event")} className="nav2-link" aria-current="page" href={`${process.env.REACT_APP_STORE_URL}`}>
                Store
              </a>
            </li>
            <li className="nav2-item">
              <Link onClick={() => goToTop("business")} className={activeItem === "business" ? "nav2-link active" : "nav2-link"} aria-current="page" to="/search?category=1&location=1&page=1&limit=10">
                Businesses
              </Link>
            </li>
            <li className="nav2-item">
              <Link onClick={() => goToTop("property")} className={activeItem === "property" ? "nav2-link active" : "nav2-link"} aria-current="page" to="/search?category=3&location=1&page=1&limit=10">
                Rooms for Rent
              </Link>
            </li>
            <li className="nav2-item">
              <Link onClick={() => goToTop("job")} className={activeItem === "job" ? "nav2-link active" : "nav2-link"} aria-current="page" to="/search?category=2&location=1&page=1&limit=10">
                Jobs
              </Link>
            </li>
            {!user ? (
              <>
                <li className="nav2-item" data-bs-toggle="modal" data-bs-target="#authModal" onClick={goToAuthModalMobile}>
                  <span className="nav2-link">Log in</span>
                </li>
                <li className="nav2-item">
                  <span className="nav2-link" data-bs-toggle="modal" data-bs-target="#authModal" onClick={goToSignup}>
                    Sign up
                  </span>
                </li>
              </>
            ) : (
              <>
                <li className="nav2-item">
                  <a className="nav2-link " href={`${process.env.REACT_APP_BASE_URL}/register`}>
                    List for FREE
                  </a>
                </li>
                <li className="d-flex flex-column align-content-center py-3 px-2 gap-3">
                  <a className="px-2 text-dark" href={`${process.env.REACT_APP_BASE_URL}`}>
                    <PersonCircle size={20} />
                    &nbsp;&nbsp;
                    {user.email}
                  </a>
                  <span className="btn btn-nav-light" onClick={logOut}>
                    Logout
                  </span>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </>
  );
}
export default Navbar;
